import { type YDatabase } from '@databases/collab/y-database';
import { err, ok, type Result } from 'neverthrow';

import { type SdkError } from '../../types';

export function assertFieldNameUnique(
  ydb: YDatabase,
  name: string,
  excludeFieldId?: string
): Result<void, SdkError> {
  const normalized = name.trim().toLowerCase();

  for (const fieldId of ydb.fields) {
    if (fieldId === excludeFieldId) {
      continue;
    }

    const field = ydb.fieldsById[fieldId];

    if (field && field.name.trim().toLowerCase() === normalized) {
      return err({
        type: 'STATE_ERROR',
        reason: 'DUPLICATE_FIELD_NAME',
        message: `A field named '${name}' already exists`
      });
    }
  }

  return ok(undefined);
}
